import {
  BetHistoryFilterTypes,
  betStore,
  notificationStore,
  userInfoStore,
  useUserInfoStore,
} from '@pascal/pascal-core';
import { useCallback } from 'react';

export const useDemoSwitcher = () => {
  const { playerExternalId } = useUserInfoStore();
  const { liveBets, setLiveBets, setBetHistoryFilter } = betStore;

  const demoSwitcherAdditionalFunction = useCallback(() => {
    const otherBets = liveBets.filter((bet) => bet.playerExternalId);
    betStore.setDemoBetHistory([]);
    userInfoStore.setDemoInitialBalance();
    notificationStore.setNotificationType(null);
    betStore.resetBetHistory();
    setLiveBets(otherBets);
    setBetHistoryFilter(BetHistoryFilterTypes.All);
  }, [liveBets, playerExternalId]);
  return { demoSwitcherAdditionalFunction };
};
